'use client';

import React from 'react';
import styles from './loading.module.scss';
import {BlockSkeleton} from '@udemy-v2/react-reveal-components';

export function Loading() {
    return (
        <div className={styles['loading-container']}>
            <BlockSkeleton className={styles['loading-block']} />
        </div>
    );
}
